import type { CastSection, CastSectionType, CastSectionVariant } from '../types';

const SECTION_TYPE_RANK: Record<CastSectionType, number> = {
  body: 1,
  footer: 2,
  header: 0,
};

const VARIANT_RANK: Record<CastSectionVariant, number> = {
  default: 0,
  even: 2,
  'first-page': 1,
};

/**
 * The canonical output order for sections: headers, then the body, then
 * footers; within a kind, `default` before `first-page` before `even`. Both the
 * serializer and the paragraph indexer sort by this so emitted output and
 * document-order indices line up regardless of the order the extractor produced.
 *
 * Returns a new array; `Array.prototype.sort` is stable, so sections that tie on
 * (type, variant) keep their relative input order.
 */
export function orderSections(sections: CastSection[]): CastSection[] {
  return [...sections].sort((a, b) => {
    const byType = SECTION_TYPE_RANK[a.sectionType] - SECTION_TYPE_RANK[b.sectionType];
    if (byType !== 0) return byType;
    return variantRank(a) - variantRank(b);
  });
}

function variantRank(section: CastSection): number {
  return section.sectionType === 'body' ? 0 : VARIANT_RANK[section.variant];
}
